import { lazy } from "react";
import RenderSubSection from "./RenderSubSections";

const LastDayOrdersPage = lazy(() => import("pages/Dashboard/LastDayOrders"));
const BesrtSellerPage = lazy(() => import("pages/Dashboard/BestSeller"));
const SalesDetailPage = lazy(() => import("pages/Dashboard/SalesDetail"));

const lastDayOrders = {
    name: "سفارش‌های دیروز",
    path: "/lastday-orders",
    group: "lastday-orders",
    exact: true,
    component: () => <LastDayOrdersPage />,
};

const bestSeller = {
    name: "محصولات پرفروش",
    path: "/best-seller-products",
    group: "best-seller-products",
    exact: true,
    component: () => <BesrtSellerPage />,
};

const salesDetail = {
    name: "ریز فروش",
    path: "/sales-detail",
    group: "sales-detail",
    exact: true,
    component: () => <SalesDetailPage />,
};
const subSections = {
    yesterdayOrders: {
        list: { ...lastDayOrders },
    },
    bestseller: {
        list: { ...bestSeller },
    },
    saleDetails: {
        list: { ...salesDetail },
    },
};

const dashboardSection = {
    title: "داشبورد",
    key: "dashboard",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default dashboardSection;
